import { render, staticRenderFns } from "./ShopArticles.vue?vue&type=template&id=75019902&scoped=true&"
import script from "./ShopArticles.vue?vue&type=script&lang=js&"
export * from "./ShopArticles.vue?vue&type=script&lang=js&"
import style0 from "./ShopArticles.vue?vue&type=style&index=0&id=75019902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75019902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VIcon,VProgressCircular})
